import React from "react"

import { styled } from "@mui/styles"

import { getFileType } from "@cirrus/common/helpers/getFileType"
import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button, SupportedFileType } from "@cirrus/ui-kit-ts"

import { Files } from "../../types/Files"

interface IProps {
  files: Files,
  fileCount: number,
  maxAttachments: number,
  maxAttachmentSize: number,
  onSave: () => void,
  onClose: () => void,
}

export const ActionButtons = ({ files, fileCount, maxAttachments, maxAttachmentSize, onSave, onClose }: IProps) => {
  const { i18n } = useTranslations()

  const attachmentsLimitReached = fileCount > maxAttachments

  const isSaveDisabled = attachmentsLimitReached
    || !(files || []).length
    || hasNotSupportedFile(files, maxAttachmentSize)

  const save = () => {
    onSave()
    onClose()
  }

  return <Wrapper>
    <Button
      onClick={save}
      disabled={isSaveDisabled}
      color="success"
      size="medium"
      label={i18n("General:Attach")}
      variant="contained" />

    <Button
      onClick={onClose}
      size="medium"
      label={i18n("General:Cancel")}
      variant="outlined" />
  </Wrapper>
}

const Wrapper = styled("div")({
  display: "flex",
  gap: "2.4rem"
})

const hasNotSupportedFile = (files: Files, maxAttachmentSize: number) =>
  Array
    .from(files || [])
    .some((file) => {
      const type = getFileType(file.name)
      return !Object.keys(SupportedFileType).includes(type)
        || file.size > maxAttachmentSize
    })
